import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {InformType} from '../../../../global/util/enum/InformType';
import {PersonService} from '../../../service/person.service';
import {Person} from '../../../model/Person';
import {JobService} from '../../../service/job.service';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Constant} from '../../../../global/util/Constant';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {AuthService} from '../../../service/auth/auth.service';
import {EnterpriseService} from '../../../service/enterprise.service';
import {Enterprise} from '../../../model/Enterprise';
import {Partner} from '../../../model/Partner';
import {Dialog} from '../../../../global/util/Dialog';
import {StringUtil} from '../../../../global/util/StringUtil';
import {Role} from '../../../model/Role';
import {AddEditEnterpriseComponent} from '../../enterprise/add-edit-enterprise/add-edit-enterprise.component';
import {TypeSignature} from '../../../../global/util/TypeSignature';
import {ParticipantType} from '../../../../global/util/enum/ParticipantType';
import {Select2Option} from 'ng-select2-component';
import {Label} from '../../../model/Label';
import {StateSolcert} from '../../../../global/util/validator/StateSolcert';
import {IdentificationDocument} from '../../../../global/util/IdentificationDocument';
import {TranslateService} from '@ngx-translate/core';
import {MoreAboutPerson} from '../../../model/common/MoreAboutPerson';
import {UnitMeasure} from '../../../../global/util/UnitMeasure';
import {NgxImageCompressService} from 'ngx-image-compress';
import {DomSanitizer, SafeStyle, SafeUrl} from '@angular/platform-browser';
import {TermPdfViewerComponent} from '../../../../shared/term-pdf-viewer/term-pdf-viewer.component';
import {PersonDocumentType} from '../../../../global/util/PersonDocumentType';
import {Temporarypasswordchange} from '../../../model/Temporarypasswordchange';
import {Passwordsecuritylevel} from '../../../model/Passwordsecuritylevel';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-add-person',
  templateUrl: './add-edit-person.component.html',
  styleUrls: ['./add-edit-person.component.css']
})
export class AddEditPersonComponent implements OnInit, OnDestroy {
  public entityName = 'TITLE.PERSON';
  public personForm: FormGroup;
  public loading: boolean;
  public participantTypes: any[] = [];
  public jobs: any[] = [];
  public countries: any[] = [];
  public enterprisesFounded: Enterprise[] = [];
  public enterprises: Enterprise[] = [];
  public partners: Partner[] = [];
  public personTypes: any[] = [];
  public participantTypeSelected: number;
  public roles: any[] = [];
  public personReceived: Person;
  public enterpriseViewSelected: Enterprise;
  public purpose4Form: number;
  public documentId: number;
  public searched = true;
  public typePerson: number;
  public typeSignature: number;
  public addSearchPersonSelected;
  public jobId: number;
  public identificationDocuments: any[] = [];
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public enterpriseViewnameSelected: string;
  public editOnSign = false;
  private partnerIdSelected: number;
  public rubricSrc: string | ArrayBuffer;
  public documentFrontSrc: string | ArrayBuffer;
  public documentRearSrc: string | ArrayBuffer;
  public pwfile: string | SafeStyle;
  public rucfile: string | SafeStyle;
  public previewRubricWidth = '180';
  private readonly DEFAULT_COUNTRY = 168;
  private stampRubric: boolean;
  public incompleteData: boolean;
  private hasImagesDocument: boolean;
  // indica si cuenta con su vigencia de poder
  public hasPowerValidity = false;
  public hasPowerValidity3 = false;
  public hasRUCFile = false;
  public hasRUCFile3 = false;
  // Estado de la solicitud de validación de documentos.
  public stateId: number;
  // Observación de la solicitud de validación de documentos.
  public observation: string;
  /**
   * Indica que, si una firma gráfica está después de una firma digital o firma Onesign, el usuario tenga la
   * obligación de cargar su rúbrica
   * @private
   */
  public addRubric: boolean;
  public checkedAddImgDocument = false;
  @ViewChild('rubricPic', {static: false}) rubricPic: ElementRef;
  public selectableLabels: Select2Option[] = [];
  public labels: Label[];
  public hasRoleSimple: boolean;
  public twoFactorAuthentication: boolean;
  public changePasswordTemporary: boolean;
  public moreAboutPerson: MoreAboutPerson;
  private imageCompress: string | ArrayBuffer = '';
  private sizeOfOriginalImage: number;
  private files: number[] = [];
  public documents: any;
  public urlPowerValidity: any;
  public urlRUCFile: any;
  public POWER_VALIDITY = PersonDocumentType.POWER_VALIDITY;
  public RUC_FILE = PersonDocumentType.RUC_FILE;
  public passwordLevel = 0;
  public passwordSecurityLevel: any;
  public passwordLevelMedioChecked = false;
  public passwordLevelHighChecked = false;
  public dateTypes: any;

  constructor(public activeModal: NgbActiveModal,
              private sanitizer: DomSanitizer,
              private formBuilder: FormBuilder,
              private personService: PersonService,
              private jobService: JobService,
              private authenticationService: AuthService,
              private enterpriseService: EnterpriseService,
              private enterpriseDataService: EnterpriseDataService,
              private modalService: NgbModal,
              private translate: TranslateService,
              private imageCompressService: NgxImageCompressService) {
    Dialog.createInstance(modalService);
    this.setDefaultValues();
    this.createForm();
  }

  private setDefaultValues(): void {
    this.labels = LocalStorage.getLabels();
  }

  ngOnInit() {
    /**
     * Si existen etiquetas registradas para la persona; construye la lista seleccionada de acuerdo a la estructura
     * requerida
     */
    if (this.labels) {
      this.selectableLabels = this.labels.map(val => {
        const select2Option: Select2Option = {value: val.id, label: val.code, disabled: false};
        return select2Option;
      });
    }
    this.typePerson = Number(this.typePerson);
    this.configGlobalData();
    switch (this.purpose4Form) {
      case Constant.ADD:
        this.moreAboutPerson = new MoreAboutPerson();
        this.participantTypeSelected = Constant.USER;
        this.personReceived.countryId = this.DEFAULT_COUNTRY;
        this.participantTypeChange();
        this.dateTypes = LocalStorage.getDatetypes();
        this.personForm.get('dateType').setValue(this.dateTypes[0]);
        break;
      case Constant.EDIT:
        this.dateTypes = LocalStorage.getDatetypes();
        this.personReceived.labelIds = this.personReceived._more.labels;
        this.participantTypeSelected = this.personReceived._more.participantType;
        this.hasImagesDocument = this.personReceived._more.hasImagesDocument;
        this.loadRequiredData();
        this.loadValidations();
        this.loadResourcePerson();
        this.personReceived.documentType = +this.personReceived.documentType;
        this.personReceived.jobId = +this.personReceived._more.jobId;
        this.personReceived.roles = this.getFirstRole(this.personReceived._more.roles);
        this.enterpriseViewSelected.id = this.personReceived.enterpriseIdView;
        this.enterpriseViewnameSelected = this.personReceived._more.enterpriseDocumentNumberView + '-' + this.personReceived._more.enterpriseNameView;
        const rubricFilename2Show = this.personReceived._more.rubricFilename;
        this.personForm.get('rubricFilename2Show').setValue(rubricFilename2Show);
        this.loadRubricSrc(this.personReceived);
        const documentFrontFilename2Show = this.personReceived._more.documentFrontFilename;
        this.personForm.get('documentFrontFilename2Show').setValue(documentFrontFilename2Show);
        this.loadDocumentFrontSrc(this.personReceived);
        const documentRearFilename2Show = this.personReceived._more.documentRearFilename;
        this.personForm.get('documentRearFilename2Show').setValue(documentRearFilename2Show);
        this.loadDocumentRearSrc(this.personReceived);
        if (this.personReceived._more.hasPowerValidity || this.hasPowerValidity) {
          this.personForm.get('filename2Show').setValue('vigencia de poder.pdf');
        }
        if (this.personReceived._more.hasRUCFile || this.hasRUCFile) {
          this.personForm.get('rucFilename2Show').setValue('Ficha RUC.pdf');
        }
        this.loadDocumentpwfile(this.personReceived);
        this.twoFactorAuthentication = this.personReceived._more.haveTwoFactorAuthentication;
        this.hasRoleSimple = this.isRoleSimple(this.roles.find(role => role.id === this.personReceived.roles));
        this.changePasswordTemporary = this.personReceived._more.haveChangePasswordTemporary;
        if (this.changePasswordTemporary) {
          const dateTypeId = this.personReceived._more.temporaryPasswordChange.dateTypeId;
          const timeOnNumber = this.personReceived._more.temporaryPasswordChange.timeOnNumber;
          this.personForm.get('dateType').setValue(this.dateTypes.find((dateType: any) => dateType.id === dateTypeId));
          this.personForm.get('timeOnNumber').setValue(timeOnNumber);
        } else {
          this.personForm.get('dateType').setValue(this.dateTypes[Constant.ZERO_INDEX]);
        }
        this.passwordSecurityLevel = this.personReceived._more.haveSecurityLevelPassword;
        if (this.passwordSecurityLevel) {
          this.passwordLevel = this.personReceived._more.passwordSecurityLevel.level;
          this.passwordLevelHighChecked = this.passwordLevel === 1;
          this.passwordLevelMedioChecked = this.passwordLevel === 2;
          this.personForm.get('passwordHighLevel').setValue(this.passwordLevelHighChecked);
          this.personForm.get('passwordMedioLevel').setValue(this.passwordLevelMedioChecked);
        } else {
          this.personForm.get('passwordHighLevel').setValue(1);
        }
        break;
      case Constant.ADD_ON_DOCS:
        this.participantTypeSelected = Constant.INVITED;
        this.addSearchPersonSelected = String(Constant.ADD_ON_DOCS);
        this.personReceived.countryId = this.DEFAULT_COUNTRY;
        if (TypeSignature.CLOUD === this.typeSignature) {
          this.personForm.get('phoneNumber').setValidators(
            Validators.compose(
              [
                Validators.required,
                Validators.pattern('^[0-9]{9,}')])
          );
          this.checkedAddImgDocument = true;
          this.personForm.get('phoneNumber').updateValueAndValidity();
        }
        if (this.addRubric) {
          this.personForm.get('rubricFilename2Show').setValidators(Validators.required);
          this.personForm.get('rubricFilename2Show').updateValueAndValidity();
        }
        this.participantTypeChange();
        break;
      case Constant.EDIT_ON_DOCS:
        this.loadResourcePerson();
        this.loadRequiredData();
        this.personForm.get('addSearchOpt').clearValidators();
        this.personForm.get('addSearchOpt').updateValueAndValidity();
        this.personReceived.jobId = this.personReceived._more.jobId;
        this.personReceived.scope = this.personReceived._more.participantType;
        this.personReceived.documentType = +this.personReceived.documentType;
        this.enterpriseViewnameSelected = this.personReceived._more.enterpriseDocumentNumberView + '-' + this.personReceived._more.enterpriseNameView;
        this.addSearchPersonSelected = String(Constant.EDIT_ON_DOCS);
        this.participantTypeSelected = this.personReceived._more.participantType;
        this.personReceived.roles = this.getFirstRole(this.personReceived._more.roles);
        this.search();
        const rubricFilename2Show1 = this.personReceived._more.rubricFilename;
        this.personForm.get('rubricFilename2Show').setValue(rubricFilename2Show1);
        if (TypeSignature.CLOUD === this.typeSignature) {
          this.checkedAddImgDocument = true;
          if (this.editOnSign) {
            this.personForm.get('enterpriseName').clearValidators();
            this.personForm.get('documentFrontFilename2Show').setValidators(Validators.required);
            this.personForm.get('documentFrontFilename2Show').updateValueAndValidity();
            this.personForm.get('documentRearFilename2Show').setValidators(Validators.required);
            this.personForm.get('documentRearFilename2Show').updateValueAndValidity();
            if (this.typePerson === Constant.LEGAL_PERSON) {
              if (!this.hasPowerValidity) {
                this.personForm.get('filename2Show').setValidators(Validators.required);
                this.personForm.get('filename2Show').updateValueAndValidity();
              } else {
                this.personForm.get('filename2Show').setValue('Vigencia de poder.pdf');
              }
              if (!this.hasRUCFile) {
                this.personForm.get('rucFilename2Show').setValidators(Validators.required);
                this.personForm.get('rucFilename2Show').updateValueAndValidity();
              } else {
                this.personForm.get('rucFilename2Show').setValue('Ficha RUC.pdf');
              }
            }
          }
          this.personForm.get('phoneNumber').setValidators(
            Validators.compose(
              [
                Validators.required,
                Validators.pattern('^[0-9]{9,}')])
          );
          this.personForm.get('phoneNumber').updateValueAndValidity();
        }
        if (this.stampRubric) {
          this.personForm.get('rubricFilename2Show').setValidators(Validators.required);
          this.personForm.get('rubricFilename2Show').updateValueAndValidity();
        }
        break;
    }
  }

  ngOnDestroy() {
    const items = [
      'jobs',
      'roles',
      'persontypes',
      'identificationdocuments',
      // 'countries',
      // TODO sobre Countries: retiramos la eliminación de esta propiedad ya que se necesita en OneSign, pero mejor sería
      //  hacer la adecuación de carga en dicho módulo
      'labels'];
    LocalStorage.removeItems(items);
  }

  private configGlobalData() {
    this.loadGlobalDefaultData();
    this.setGlobalDefaultData();
  }

  public participantTypeChange() {
    this.loadRequiredData();
    this.loadInitialValues();
    this.loadValidations();
  }

  public loadRequiredData() {
    this.participantTypes = LocalStorage.getParticipantTypes();
    this.personTypes = LocalStorage.getPersonTypes();
    this.identificationDocuments = LocalStorage.getIdentificationdocuments();
    if (this.participantTypeSelected !== Constant.INVITED_USER) {
      this.roles = LocalStorage.getRoles();
    } else {
      this.loadRole4InvitedUser();
    }
    this.enterpriseViewSelected = new Enterprise();
    this.enterpriseViewnameSelected = '';
    this.setTypeIds(this.roles);
  }

  private setTypeIds(roles: any[]) {
    roles.forEach(role => role.id = String(role.id));
  }

  public loadInitialValues() {
    if (this.purpose4Form === Constant.SEARCH_ON_DOCS) {
      this.loadInitialValues4SearchOnDocs();
    } else {
      switch (this.participantTypeSelected) {
        case Constant.USER:
          this.setInitialValues4User();
          break;
        case Constant.INVITED_USER:
          this.setInitialValues4UserInvited();
          break;
        case Constant.INVITED:
          this.setInitialValues4Invited();
          break;
      }
    }
  }

  public loadInitialValues4SearchOnDocs() {
    if (this.participantTypeSelected !== Constant.INVITED) {
      this.removeNaturalPersonOption();
      switch (this.participantTypeSelected) {
        case Constant.USER:
          this.personReceived.roles = '';
          this.personReceived.type = this.personTypes[Constant.ZERO_INDEX].id;
          this.personReceived.documentType = this.identificationDocuments[Constant.ZERO_INDEX].id;
          this.personReceived.jobId = this.jobs[Constant.ZERO_INDEX].id;
          this.personReceived.scope = Constant.USER;
          break;
        case Constant.INVITED_USER:
          this.personReceived.roles = '';
          this.personReceived.type = this.personTypes[Constant.ZERO_INDEX].id;
          this.personReceived.documentType = this.identificationDocuments[Constant.ZERO_INDEX].id;
          this.personReceived.scope = Constant.INVITED_USER;
          break;
      }
    } else {
      this.setInitialValues4Invited();
    }
  }

  public loadValidations() {
    switch (this.participantTypeSelected) {
      case Constant.USER:
        if (this.purpose4Form === Constant.SEARCH_ON_DOCS) {
          this.personForm.get('enterpriseName').clearValidators();
          this.personForm.get('job').clearValidators();
          this.personForm.get('rol').clearValidators();
        }
        break;
      case Constant.INVITED_USER:
        this.personForm.get('enterpriseName').setValidators(Validators.required);
        this.personForm.get('job').setValidators(Validators.required);
        this.personForm.get('rol').clearValidators();
        break;
      case Constant.INVITED:
        this.personForm.get('enterpriseName').clearValidators();
        this.personForm.get('job').clearValidators();
        this.personForm.get('rol').clearValidators();
        break;
    }
    this.personForm.get('enterpriseName').updateValueAndValidity();
    this.personForm.get('job').updateValueAndValidity();
    this.personForm.get('rol').updateValueAndValidity();

    switch (this.purpose4Form) {
      case Constant.ADD:
      case  Constant.EDIT:
        this.personForm.get('addSearchOpt').clearValidators();
        break;
      case Constant.ADD_ON_DOCS:
      case Constant.SEARCH_ON_DOCS:
        this.personForm.get('addSearchOpt').setValidators(Validators.required);
        break;
      case  Constant.EDIT_ON_DOCS:
        this.personForm.get('addSearchOpt').clearValidators();
        break;
    }
    this.personForm.get('addSearchOpt').updateValueAndValidity();
  }

  public setInitialValues4User() {
    this.removeNaturalPersonOption();
    this.personReceived.roles = this.getRoleOf(Constant.ROLE_USER).id;
    this.personReceived.type = this.personTypes[Constant.ZERO_INDEX].id;
    this.enterpriseViewSelected = this.findBy(this.personReceived.enterpriseId);
    this.enterpriseViewnameSelected = this.getEnterpriseViewame4User();
    this.personReceived.documentType = this.identificationDocuments[0].id;
    this.personReceived.jobId = this.jobs[Constant.ZERO_INDEX].id;
    this.personReceived.scope = Constant.USER;
  }

  public setInitialValues4UserInvited() {
    this.removeNaturalPersonOption();
    this.personReceived.roles = this.getRoleOf(Constant.ROLE_USER).id;
    this.personReceived.type = this.personTypes[Constant.ZERO_INDEX].id;
    this.personReceived.documentType = this.identificationDocuments[0].id;
    this.personReceived.jobId = this.jobs[Constant.ZERO_INDEX].id;
    this.personReceived.scope = Constant.INVITED_USER;
  }

  public setInitialValues4Invited() {
    // Solo se mostrara persona juridica cuando sea un participante de tipo onesign Juridica, y al momento de cargar un documento
    if (this.typeSignature) {
      if (this.typeSignature === TypeSignature.CLOUD) {
        if (this.typePerson === Constant.LEGAL_PERSON) {
          this.removeNaturalPersonOption();
        }
      }
    }
    this.personReceived.roles = '';
    this.personReceived.type = this.personTypes[Constant.ZERO_INDEX].id;
    this.personReceived.documentType = this.identificationDocuments[Constant.ZERO_INDEX].id;
    this.personReceived.jobId = this.jobs[Constant.ZERO_INDEX].id;
    this.personReceived.scope = Constant.INVITED;
  }

  public getRoleOf(roleName: string) {
    return this.roles.find(role => role.name === roleName);
  }

  private upperCase2Fields() {
    this.personReceived.firstname = this.personReceived.firstname.toUpperCase();
    this.personReceived.lastname = this.personReceived.lastname.toUpperCase();
    this.personReceived.lastname2 = this.personReceived.lastname2.toUpperCase();
  }

  public getEnterpriseViewame4User(): string {
    if (this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_SUPERADMIN)) {
      const enterprise: Enterprise = this.findBy(this.personReceived.enterpriseId);
      return enterprise.documentNumber + ' - ' + enterprise.name;
    }
    return LocalStorage.getEnterpriseDocumentNumberView() + ' - ' + LocalStorage.getEnterpriseNameView();
  }

  private findBy(entepriseId): Enterprise {
    return this.enterprises.find(value => value.id === entepriseId);
  }

  public removeNaturalPersonOption() {
    const index = this.getIndexPersonTypeOf(Constant.NATURAL_PERSON);
    if (index >= 0) {
      this.personTypes.splice(index, 1);
    }
  }

  private getIndexPersonTypeOf(personType: any): number {
    return this.personTypes.findIndex(value => value.id === personType);
  }

  get isUserParticipant(): boolean {
    return Constant.USER === this.participantTypeSelected;
  }

  get isUserInvitedParticipant(): boolean {
    return Constant.INVITED_USER === this.participantTypeSelected;
  }

  get isInvitedParticipant(): boolean {
    return Constant.INVITED === this.participantTypeSelected;
  }

  public save() {
    if (this.personForm.invalid) {
      this.markAsTouchedAllControls();
      return;
    }
    this.upperCase2Fields();
    switch (this.purpose4Form) {
      case Constant.ADD:
        this.register();
        break;
      case Constant.EDIT:
        this.edit();
        break;
      case Constant.ADD_ON_DOCS:
        this.register2();
        break;
      case Constant.SEARCH_ON_DOCS:
        if (TypeSignature.CLOUD === this.typeSignature || TypeSignature.ELECTRONIC === this.typeSignature) {
          this.edit();
          this.activeModal.close(this.personReceived);
        } else if (this.personReceived.id) {
          this.edit();
        }
        break;
      case Constant.EDIT_ON_DOCS:
        this.edit();
        this.activeModal.close(Constant.EDIT_ON_DOCS);
        break;
    }
  }

  private markAsTouchedAllControls() {
    Object.values(this.personForm.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  private markAsUntouchedAllControls() {
    Object.values(this.personForm.controls).forEach(control => {
      control.markAsUntouched();
    });
  }

  public register() {
    this.setFinalValuesBefore2Save();
    this.loading = true;
    this.personService.save(this.personReceived).subscribe(() => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
      this.removeItem();
    }, error => {
      this.loading = false;
      if (error.status === HttpStatusCode.FOUND) {
        this.activeModal.close(InformType.Warning);
      } else {
        this.activeModal.close(InformType.Danger);
      }
    });
  }

  public register2() {
    this.setFinalValuesBefore2Save();
    this.loading = true;
    this.personService.save(this.personReceived).subscribe(person => {
      this.loading = false;
      this.activeModal.close(person);
      this.removeItem();
    }, error => {
      this.loading = false;
      if (error.status === HttpStatusCode.FOUND) {
        this.activeModal.close(error.error);
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.PERSON'));
      } else {
        this.activeModal.close(InformType.Danger);
      }
    });
  }

  public setFinalValuesBefore2Save() {
    switch (this.participantTypeSelected) {
      case Constant.USER:
        if (this.enterpriseViewSelected && this.enterpriseViewSelected.id) {
          this.personReceived.enterpriseIdView = this.enterpriseViewSelected.id;
        } else {
          if (Constant.EDIT_ON_DOCS !== this.purpose4Form) {
            this.personReceived.enterpriseIdView = LocalStorage.getEnterpriseIdView();
          }
        }
        break;
      case Constant.INVITED_USER:
        this.personReceived.enterpriseIdView = this.enterpriseViewSelected.id;
        break;
      case Constant.INVITED:
        if (!this.isNaturalPerson) {
          this.personReceived.enterpriseIdView = this.enterpriseViewSelected.id;
        }
        break;
    }
    if (this.isNaturalPerson) {
      this.personReceived.roles = '';
      this.personReceived.jobId = Constant.DEFAULT_JOB_ID;
      this.personReceived.enterpriseIdView = Constant.DEFAULT_ENTERPRISE_ID_VIEW;
    }
    if (this.changePasswordTemporary) {
      const temporaryChangePassword = new Temporarypasswordchange();
      const dateType = this.personForm.get('dateType').value;
      temporaryChangePassword.dateTypeId = dateType.id;
      temporaryChangePassword.timeOnNumber = this.personForm.get('timeOnNumber').value;
      this.moreAboutPerson.temporaryPasswordChange = temporaryChangePassword;
    }
    if (this.passwordSecurityLevel) {
      const passwordSecurityLevel = new Passwordsecuritylevel();
      this.passwordLevel = this.passwordLevelMedioChecked ? 2 : 1;
      passwordSecurityLevel.level = this.passwordLevel;
      this.moreAboutPerson.passwordSecurityLevel = passwordSecurityLevel;
    }
    this.moreAboutPerson.haveChangePasswordTemporary = this.changePasswordTemporary;
    this.moreAboutPerson.haveSecurityLevelPassword = this.passwordSecurityLevel;
    this.personReceived.rubricBase64Data = this.getImageCompress(this.personForm.get('rubricFileBase64').value, 'rubricFileBase64');
    this.personReceived.rubricFilename = this.personForm.get('rubricFilename').value;
    this.personReceived.documentFrontBase64Data = this.getImageCompress(this.personForm.get('documentFrontFileBase64').value, 'documentFrontFileBase64');
    this.personReceived.documentFrontFilename = this.personForm.get('documentFrontFilename').value;
    this.personReceived.documentRearBase64Data = this.getImageCompress(this.personForm.get('documentRearFileBase64').value, 'documentRearFileBase64');
    this.personReceived.documentRearFilename = this.personForm.get('documentRearFilename').value;
    this.personReceived.file = this.getImageCompress(this.personForm.get('file').value, 'file');
    this.personReceived.filename = this.personForm.get('filename').value;
    this.personReceived.rucFileBase64Data = this.getImageCompress(this.personForm.get('rucFile').value, 'file');
    this.personReceived.rucFilename = this.personForm.get('rucFilename').value;
    this.personReceived.labels = this.joinLabelCodes;
    this.personReceived.moreAboutPerson = this.moreAboutPerson;
  }

  get joinLabelCodes(): string {
    let s = '';
    if (this.personReceived.labelIds) {
      this.personReceived.labelIds.forEach(value => {
        s += this.labels.find(value1 => value1.id === value).code + ';';
      });
    }
    return s;
  }

  public edit() {
    this.setFinalValuesBefore2Save();
    this.loading = true;
    this.personReceived.scope = this.participantTypeSelected;
    this.personService.edit(this.personReceived).subscribe(next => {
      if (Constant.EDIT_ON_DOCS === this.purpose4Form && this.typeSignature === TypeSignature.CLOUD && !this.incompleteData) {
        this.generateRequestInSolcert();
      }
      this.loading = false;
      this.personReceived = next;
      if (Constant.SEARCH_ON_DOCS === this.purpose4Form) {
        this.activeModal.close(this.personReceived);
      } else {
        this.activeModal.close(InformType.Success);
      }
      this.removeItem();
    }, () => {
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  /**
   * Genera solicitud de validación de persona en el solcert
   */
  public generateRequestInSolcert(): void {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/personconfirmations');
    const formData = new FormData();
    formData.append('typePerson', this.typePerson.toString());
    formData.append('documentIds', String(this.documentId));
    this.personService.createRequestSolcert1(url, formData).subscribe(() => {
      Dialog.show(InformType.Success, this.translate.instant('TITLE.CORRECTLY-COMPLETED-DATA'), this.translate.instant('MESSAGE.VALIDATE-INFORMATION-FOR-REGISTRATION-OPERATOR'));
      this.loading = false;
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.CREATION-OF-REQUEST'));
    });
  }

  get isNewPerson(): boolean {
    return this.personReceived.id === undefined;
  }

  public cancel() {
    this.activeModal.close(Constant.CANCEL);
  }

  public loadEnterprises(event: any) {
    const nameOrDocnumber = event.target.value;
    if (nameOrDocnumber) {
      if (nameOrDocnumber.length > 3) {
        const findDistinctUrl = Constant.ROOT_API_V1
          .concat('/participants/')
          .concat(String(this.participantTypeSelected))
          .concat('/enterprises/')
          .concat(String(this.personReceived.enterpriseId))
          .concat('/distinct')
          .concat('?findby=')
          .concat(nameOrDocnumber);
        this.enterpriseService.get(findDistinctUrl).subscribe((next: any) => {
          if (next._embedded) {
            this.enterprisesFounded = next._embedded.enterprises;
          }
        });
      }
    }
  }

  get isNaturalPerson(): boolean {
    return Constant.NATURAL_PERSON === this.personReceived.type;
  }

  public search() {
    if (Constant.EDIT_ON_DOCS !== this.purpose4Form) {
      if (this.personForm.controls.enterpriseName.invalid
        || this.personForm.controls.documentType.invalid
        || this.personForm.controls.documentNumber.invalid
        || this.personForm.controls.job.invalid) {
        this.personForm.controls.enterpriseName.markAsTouched();
        this.personForm.controls.documentType.markAsTouched();
        this.personForm.controls.documentNumber.markAsTouched();
        this.personForm.controls.job.markAsTouched();
        return;
      }
      this.setFinalValuesBefore2Save();
    }

    const enterpriseId = this.getEnterpriseId2Search();
    const enterpriseIdView = this.personReceived.enterpriseIdView;
    const participantType = this.participantTypeSelected;
    const personType = this.personReceived.type;
    const documentType = this.personReceived.documentType;
    const documentNumber = this.personReceived.documentNumber;
    const jobId = this.personReceived.jobId;
    this.loading = true;
    const urlSearch = Constant.ROOT_API_V1
      .concat('/enterprises/')
      .concat(String(enterpriseId))
      .concat('/enterprises/')
      .concat(String(enterpriseIdView))
      .concat('/participanttypes/')
      .concat(String(participantType))
      .concat('/persontype/')
      .concat(String(personType))
      .concat('/documenttype/')
      .concat(String(documentType))
      .concat('/documentnumber/')
      .concat(documentNumber)
      .concat('/jobs/')
      .concat(String(jobId))
      .concat('/people');
    this.personService.get(urlSearch).subscribe((person: any) => {
      this.personReceived.id = person.id;
      this.personReceived.firstname = person.firstname;
      this.personReceived.lastname = person.lastname;
      this.personReceived.lastname2 = person.lastname2;
      this.personReceived.countryId = person.countryId;
      this.personReceived.email = person.email;
      this.personReceived.certificateSerialNumber = person.certificateSerialNumber;
      this.personReceived.documentType = +person.documentType;
      this.personReceived.jobId = person._more.jobId;
      this.personReceived.fullname = person.fullname;
      this.personReceived.cellphone = person.cellphone;
      this.personReceived.active = person.active;
      this.personReceived.hasPowerValidity = person._more.hasPowerValidity;
      this.personReceived.hasRUCFile = person._more.hasRUCFile;
      this.searched = true;
      this.personForm.get('rubricFilename2Show').setValue(person._more.rubricFilename);
      this.personForm.get('rubricFileBase64').setValue(person._more.base64RubricFile);
      this.personForm.get('rubricFilename').setValue(person._more.rubricFilename);
      this.personForm.get('documentFrontFilename2Show').setValue(person._more.documentFrontFilename);
      this.personForm.get('documentFrontFileBase64').setValue(person._more.documentFrontBase64Data);
      this.personForm.get('documentFrontFilename').setValue(person._more.documentFrontFilename);
      this.personForm.get('documentRearFilename2Show').setValue(person._more.documentRearFilename);
      this.personForm.get('documentRearFileBase64').setValue(person._more.documentRearBase64Data);
      this.personForm.get('documentRearFilename').setValue(person._more.documentRearFilename);
      if (person._more.rubricFilename !== null) {
        if (TypeSignature.CLOUD === this.typeSignature || TypeSignature.ELECTRONIC === this.typeSignature) {
          this.personForm.get('rubricFilename2Show').updateValueAndValidity();
        }
      }
      if (TypeSignature.CLOUD === this.typeSignature && person._more.hasImagesDocument) {
        this.hasImagesDocument = person._more.hasImagesDocument;
        this.personForm.get('documentFrontFilename2Show').updateValueAndValidity();
        this.personForm.get('documentRearFilename2Show').updateValueAndValidity();
      }
      this.loadRubricSrc(person);
      this.loadDocumentFrontSrc(person);
      this.loadDocumentRearSrc(person);
      this.loadDocumentpwfile(person);
      this.loading = false;
    }, error => {
      this.loading = false;
      if (error.status === HttpStatusCode.NOT_FOUND) {
        this.personReceived.id = undefined;
        this.personReceived.fullname = '';
        this.personReceived.firstname = '';
        this.personReceived.lastname = '';
        this.personReceived.lastname2 = '';
        this.personReceived.email = '';
        Dialog.show(InformType.Info, this.translate.instant('TITLE.PERSON'));
      } else {
        this.loadInitialValues();
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.PERSON'));
        return;
      }
    });
  }

  private loadRubricSrc(person: Person) {
    if (person && person._more.rubricFileExtension && person._more.base64RubricFile) {
      this.rubricSrc = 'data:image/' + person._more.rubricFileExtension + ';base64,' + person._more.base64RubricFile;
    } else {
      this.rubricSrc = this.placeHoldItRubric;
    }
  }

  private loadDocumentFrontSrc(person: Person) {
    if (person && person._more.documentFrontFileExtension && person._more.documentFrontBase64Data) {
      this.documentFrontSrc = 'data:image/' + person._more.documentFrontFileExtension + ';base64,' + person._more.documentFrontBase64Data;
    } else {
      this.documentFrontSrc = this.placeHoldItRubric;
    }
  }

  private loadDocumentRearSrc(person: Person) {
    if (person && person._more.documentRearFileExtension && person._more.documentRearBase64Data) {
      this.documentRearSrc = 'data:image/' + person._more.documentRearFileExtension + ';base64,' + person._more.documentRearBase64Data;
    } else {
      this.documentRearSrc = this.placeHoldItRubric;
    }
  }

  private loadDocumentpwfile(person: Person) {
    if (person && person._more.file) {
      this.pwfile = this.sanitizer.bypassSecurityTrustStyle('data:image/' + 'pdf' + ';base64,' + person._more.file);
    } else {
      this.pwfile = this.placeHoldItRubric;
    }
  }

  private getEnterpriseId2Search(): number {
    if (this.personReceived.enterpriseId === undefined) {
      return LocalStorage.getEnterpriseIdView();
    } else {
      return this.personReceived.enterpriseId;
    }
  }

  public onEnterpriseChanged(data: string) {
    if (data.includes(' - ')) {
      const documentNumber = data.split('-')[0].trim();
      this.enterpriseViewSelected = this.enterprisesFounded.find(enterprise => enterprise.documentNumber === documentNumber);
      if (this.enterpriseViewSelected) {
      } else {
        this.personForm.controls.enterpriseName.setErrors({errorEnterpriseName: true});
      }
    } else {
      this.personForm.controls.enterpriseName.setErrors({errorEnterpriseName: true});
    }
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  public createForm() {
    this.personForm = this.formBuilder.group(
      {
        partner: [''],
        enterprise: [''],
        serialnumber: [''],
        addSearchOpt: ['', Validators.required],
        type: ['', [Validators.required]],
        documentType: ['', Validators.required],
        documentNumber: ['', [Validators.required]],
        firstname: ['', Validators.compose([Validators.required,
          Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')])],
        lastname: ['', Validators.compose([Validators.required,
          Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,60}')])],
        lastname2: ['', Validators.compose([Validators.required,
          Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,60}')])],
        groupRadio: ['', Validators.required],
        email: ['', Validators.compose([Validators.required,
          Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,9}|[0-9]{1,3})(\\]?)$')])],
        rol: ['', Validators.required],
        phoneNumber: [''],
        enterpriseName: ['', Validators.required],
        status: [''],
        job: ['', Validators.required],
        country: ['', Validators.required],
        rubricFileId: [''],
        rubricFileBase64: [''],
        rubricFilename: [''],
        rubricFilename2Show: [''],
        documentFrontFileBase64: [''],
        documentFrontFilename: [''],
        documentFrontFilename2Show: [''],
        file: [''],
        filename: [''],
        filename2Show: [''],
        rucFile: [''],
        rucFilename: [''],
        rucFilename2Show: [''],
        documentRearFileBase64: [''],
        documentRearFilename: [''],
        documentRearFilename2Show: [''],
        addDocumentImages: [''],
        label: [''],
        twoFactorAuthentication: [''],
        changePasswordTemporary: [''],
        passwordSecurityLevel: [''],
        passwordHighLevel: [0],
        passwordMedioLevel: [0],
        timeOnNumber: [1],
        dateType: []
      });
  }

  public isInvalidControl(ctrlName: string) {
    return this.personForm.get(ctrlName).invalid && this.personForm.get(ctrlName).touched;
  }

  public onChangeDocType() {
    const documentType = this.personReceived.documentType;
    switch (documentType) {
      case IdentificationDocument.DNI:
        this.personForm.get('documentNumber').setValidators(
          Validators.compose(
            [
              Validators.required,
              Validators.pattern('^[0-9]{8}')])
        );
        break;
      case IdentificationDocument.CE:
        this.personForm.get('documentNumber').setValidators(
          Validators.compose(
            [
              Validators.required,
              Validators.pattern('^[0-9]{9,11}')])
        );
        break;
      case IdentificationDocument.PAS:
        this.personForm.get('documentNumber').setValidators(
          Validators.compose(
            [
              Validators.required,
              Validators.pattern('^[a-zA-Z0-9]{7,20}')])
        );
        break;
    }
    this.personForm.get('documentNumber').updateValueAndValidity();
  }

  get documentNumber() {
    return this.personForm.get('documentNumber');
  }

  public getErrorMessageBy(controlName: string): string {
    const control = this.personForm.get(controlName);
    const hasRequiredError = control.hasError('required');
    const hasPatternError = control.hasError('pattern');
    let actualValue;
    switch (controlName) {
      case 'documentNumber':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.ENTER-THE')
            .concat(this.getDescriptionOfDocumentTypeBy(this.personReceived.documentType))
            .concat(this.translate.instant('MESSAGE.REQUIRED'));
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return '\''
            .concat(String(actualValue))
            .concat(this.translate.instant('MESSAGE.NOT-COMPLY-WITH-REQUIRED'))
            .concat(this.getDescriptionOfDocumentTypeBy(this.personReceived.documentType));
        }
        break;
      case 'phoneNumber':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.ENTER-THE')
            .concat(this.translate.instant('MESSAGE.TELEPHONE-NUMBER'))
            .concat(this.translate.instant('MESSAGE.REQUIRED'));
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return '\''
            .concat(String(actualValue))
            .concat(this.translate.instant('MESSAGE.NOT-COMPLY-WITH-REQUIRED'))
            .concat(this.translate.instant('MESSAGE.TELEPHONE-NUMBER'));
        }
        break;
      case 'email':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.EMAIL-IS-REQUIRED');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return '\''
            .concat(String(actualValue))
            .concat(this.translate.instant('MESSAGE.NOT-COMPLY-WITH-REQUIRED'))
            .concat(this.translate.instant('MESSAGE.EMAIL'));
        }
        break;
      case 'firstname':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.NAME-IS-REQUIRED');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-NAME');
        }
        break;
      case 'lastname':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.FATHERS-LAST-NAME-ARE-REQUIRED');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-LAST-NAMES');
        }
        break;
      case 'lastname2':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.MOTHERS-LAST-NAME-ARE-REQUIRED');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-LAST-NAMES');
        }
        break;
      case 'timeOnNumber':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.ENTER-THE-NUMBER');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.THE-NUMBER-IS-REQUIRED');
        }
        break;
    }
  }

  public getDescriptionOfDocumentTypeBy(id: number) {
    return this.identificationDocuments.find(documentType => documentType.id === id).shortdescription;
  }

  public cleanDataAfterChanges() {
    this.personReceived.firstname = '';
    this.personReceived.lastname = '';
    this.personReceived.lastname2 = '';
    this.personReceived.email = '';
    this.personForm.get('rubricFilename2Show').setValue('');
    this.personForm.get('rubricFileBase64').setValue('');
    this.loadRubricSrc(undefined);
    this.cleanDocumentImages();

  }

  public onChangePersonTypes() {
    this.reloadValidations();
    if (this.purpose4Form === Constant.SEARCH_ON_DOCS || this.purpose4Form === Constant.ADD_ON_DOCS) {
      this.personReceived.jobId = this.jobs[0].id;
    }
  }

  private reloadValidations() {
    if (this.isNaturalPerson) {
      this.personForm.get('enterpriseName').clearValidators();
      this.personForm.get('job').clearValidators();
    } else {
      if (this.purpose4Form !== Constant.SEARCH_ON_DOCS && this.participantTypeSelected !== Constant.USER) {
        this.personForm.get('enterpriseName').setValidators(Validators.required);
        this.personForm.get('job').setValidators(Validators.required);
      }
    }
    this.personForm.get('enterpriseName').updateValueAndValidity();
    this.personForm.get('job').updateValueAndValidity();
  }

  public getFirstRole(roles: string) {
    return roles.split(',')[0];
  }

  public onAddSearchChange() {
    this.participantTypeSelected = Constant.INVITED;
    this.personReceived = new Person();
    this.personForm.get('rubricFilename2Show').setValue('');
    this.personForm.get('rubricFileBase64').setValue('');
    this.loadRubricSrc(undefined);
    this.cleanDocumentImages();
    this.participantTypeChange();
    this.markAsUntouchedAllControls();
    switch (+this.addSearchPersonSelected) {
      case Constant.ADD_ON_DOCS:
        this.purpose4Form = Constant.ADD_ON_DOCS;
        this.searched = true;
        this.personReceived.countryId = this.DEFAULT_COUNTRY;
        break;
      case Constant.SEARCH_ON_DOCS:
        if (TypeSignature.CLOUD !== this.typeSignature) {
          this.checkedAddImgDocument = false;
        }
        this.searched = false;
        this.purpose4Form = Constant.SEARCH_ON_DOCS;
        break;
    }
    this.personReceived.enterpriseId = LocalStorage.getEnterpriseIdView();
    this.personReceived.partnerId = LocalStorage.getPartnerId();
  }

  public showByAddOrSearchType(participantType: any) {
    if (this.showMoreOptionsOfAddSearchOnDocs) {
      if (Constant.USER === participantType.id || Constant.INVITED_USER === participantType.id) {
        return !this.disableOnSearchOptSelected;
      }
      return true;
    }
    return true;
  }

  get showMoreOptionsOfAddSearchOnDocs(): boolean {
    return this.purpose4Form === Constant.ADD_ON_DOCS || this.purpose4Form === Constant.SEARCH_ON_DOCS || this.purpose4Form === Constant.EDIT_ON_DOCS;
  }

  get disableOnSearchOptSelected(): boolean {
    return Constant.SEARCH_ON_DOCS !== this.purpose4Form;
  }

  get disableAfterSearch(): boolean {
    return this.searched;
  }


  get disableOnSearchOptionSelected(): boolean {
    if (TypeSignature.CLOUD !== this.typeSignature) {
      return Constant.SEARCH_ON_DOCS !== this.purpose4Form || this.addRubric;
    } else if (Constant.ADD_ON_DOCS === this.purpose4Form) {
      return true;
    } else {
      return Constant.EDIT_ON_DOCS === this.purpose4Form || this.stampRubric;
    }
  }

  get disableOnEditOnDocuments(): boolean {
    return Constant.EDIT_ON_DOCS !== this.purpose4Form;
  }

  /**
   * Verifica si la solicitud de validación de documentos es rechazada.
   */
  get isObserved(): boolean {
    return Constant.EDIT_ON_DOCS === this.purpose4Form && StateSolcert.REFUSED === this.stateId && this.stateId !== undefined;
  }

  /**
   * Obtiene el detalle de la observación de la validación de documentos.
   */
  get getObservation(): string {
    return 'Estado de validación: Observado<br />' + 'Motivo: ' + this.observation;
  }

  get disableOnSearchOptSelectedOnImput(): boolean {
    if (TypeSignature.CLOUD !== this.typeSignature) {
      return Constant.SEARCH_ON_DOCS !== this.purpose4Form;
    } else {
      return true;
    }
  }

  get disableOnEditOptSelected(): boolean {
    return Constant.EDIT === this.purpose4Form;
  }

  public reloadData() {
    switch (this.participantTypeSelected) {
      case Constant.USER:
        this.enterpriseViewSelected = this.findBy(this.personReceived.enterpriseId);
        this.enterpriseViewnameSelected = this.getEnterpriseViewame4User();
        break;
      case Constant.INVITED_USER:
        if (Constant.ADD === this.purpose4Form) {
          this.enterpriseViewnameSelected = '';
        }
        break;
      case Constant.INVITED:
        break;
    }
    this.jobs = LocalStorage.getJobsBy(this.personReceived.enterpriseId);
    this.personReceived.jobId = this.jobs[0].id;
  }

  private loadGlobalDefaultData() {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartners();
      if (!this.isNewPerson) {
        this.enterprises = this.getEnterprises(this.personReceived.partnerId);
        // this.getEnterprisesByPartner(this.personReceived.partnerId);
        this.jobs = LocalStorage.getJobsBy(this.personReceived.enterpriseId);
      }
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      // this.getEnterprisesByPartner(partnerId);
      this.enterprises = this.getEnterprises(partnerId);
    } else {
      if (Constant.EDIT_ON_DOCS !== this.purpose4Form) {
        const enterpriseId = LocalStorage.getEnterpriseIdView();
        this.jobs = LocalStorage.getJobsBy(enterpriseId);
      }
    }
    this.countries = LocalStorage.getCountries();
  }

  private setGlobalDefaultData() {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (this.isNewPerson) {
        this.personReceived.partnerId = this.partners[Constant.ZERO_INDEX].id;
        this.enterprises = this.getEnterprises(this.personReceived.partnerId);
        // this.getEnterprisesByPartner(this.personReceived.partnerId);
        this.personReceived.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
        this.jobs = LocalStorage.getJobsBy(this.personReceived.enterpriseId);
        if (this.jobs.length > 0) {
          this.personReceived.jobId = this.jobs[Constant.ZERO_INDEX].id;
        }
      }
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      if (this.isNewPerson) {
        // TODO Revisar aquí, cuando intenta registrar como partner, NO LO PERMITE
        const initialEnterprise = this.enterprises.find(value => value.id === LocalStorage.getEnterpriseId());
        this.personReceived.enterpriseId = initialEnterprise.id;
      }
      this.jobs = LocalStorage.getJobsBy(this.personReceived.enterpriseId);
      if (this.isNewPerson) {
        this.personReceived.jobId = this.jobs[0].id;
      }
      this.personReceived.partnerId = LocalStorage.getPartnerId();
    } else {
      if (this.purpose4Form !== Constant.EDIT_ON_DOCS) {
        this.personReceived.enterpriseId = LocalStorage.getEnterpriseIdView();
        this.personReceived.partnerId = LocalStorage.getPartnerId();
      } else {
        this.personReceived._more.participantType = ParticipantType.User;
      }
    }
  }

  public reloadEnterprises() {
    this.partnerIdSelected = this.personReceived.partnerId;
    // this.getEnterprisesByPartner(this.partnerIdSelected);
    this.enterprises = this.getEnterprises(this.partnerIdSelected);
    this.personReceived.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
    this.reloadData();
    // TODO AL SELECCIONAR ROL PARTNER -> PARTNER Y SELECCIONAR LA EMPE4SA
  }

  private getEnterprises(partnerId: number): Enterprise[] {
    const enterprises1 = this.enterpriseDataService.getEnterprises();
    return enterprises1.filter(value => partnerId === value.partnerId && Constant.NOT_EXCLUDED === value.excluded);
  }

  public changeStatus2(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.personForm.patchValue({
      rubricFileBase64: testFile.base64,
      rubricFilename: testFile.name,
      rubricFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityRubricFields();
  }

  public changeStatus3(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.personForm.patchValue({
      documentFrontFileBase64: testFile.base64,
      documentFrontFilename: testFile.name,
      documentFrontFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityObverseDNIFields();
  }

  public changeStatus4(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.personForm.patchValue({
      documentRearFileBase64: testFile.base64,
      documentRearFilename: testFile.name,
      documentRearFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityBackDNIFields();
  }

  public readSelectedRubric(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.rubricSrc = reader.result;
        this.verifyImageSizeAllowed(reader.result, 'rubricFileBase64');
      };
      reader.readAsDataURL(file);
    }
  }

  public readSelectedDocumentFront(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.documentFrontSrc = reader.result;
        this.verifyImageSizeAllowed(reader.result, 'documentFrontFileBase64');
      };
      reader.readAsDataURL(file);
    }
  }

  public readSelectedBackDNI(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.documentRearSrc = reader.result;
        this.verifyImageSizeAllowed(reader.result, 'documentRearFileBase64');
      };
      reader.readAsDataURL(file);
    }
  }

  public readSelectedPWfile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.pwfile = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  public readSelectedRUCfile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.rucfile = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  get defaultRubricSrc(): string | ArrayBuffer {
    return this.rubricSrc || this.placeHoldItRubric;
  }

  get defaultDocumentFrontSrc(): string | ArrayBuffer {
    return this.documentFrontSrc || this.placeHoldItRubric;
  }

  get defaultDocumentRearSrc(): string | ArrayBuffer {
    return this.documentRearSrc || this.placeHoldItRubric;
  }

  get defaultpwfile(): string | ArrayBuffer | SafeUrl {
    return this.pwfile || this.placeHoldItRubric;
  }

  get placeHoldItRubric(): string {
    return Constant.DEFAULT_IMAGE_PATH_235_150;
  }

  private updateValueAndValidityRubricFields() {
    this.personForm.get('rubricFileBase64').updateValueAndValidity();
    this.personForm.get('rubricFilename').updateValueAndValidity();
    this.personForm.get('rubricFilename2Show').updateValueAndValidity();
  }

  private updateValueAndValidityObverseDNIFields() {
    this.personForm.get('documentFrontFileBase64').updateValueAndValidity();
    this.personForm.get('documentFrontFilename').updateValueAndValidity();
    this.personForm.get('documentFrontFilename2Show').updateValueAndValidity();
  }

  private updateValueAndValidityBackDNIFields() {
    this.personForm.get('documentRearFileBase64').updateValueAndValidity();
    this.personForm.get('documentRearFilename').updateValueAndValidity();
    this.personForm.get('documentRearFilename2Show').updateValueAndValidity();
  }

  get styleDimensionsRubric(): string {
    return 'width: ' + this.previewRubricWidth + 'px; height: auto';
  }

  private removeItem() {
    LocalStorage.removeItem('rubricFileBase64');
    LocalStorage.removeItem('documentFrontFileBase64');
    LocalStorage.removeItem('documentRearFileBase64');
  }

  public applyEnterpriseValidators(): void {
    const selectedRole: Role = this.roles.find(value => value.id === this.personReceived.roles);
    const control: AbstractControl = this.personForm.get('enterprise');
    this.hasRoleSimple = this.isRoleSimple(selectedRole);
    if (this.ROLE_PARTNER === selectedRole.name) {
      const selectedEnterprise: Enterprise = this.enterprises.find(value => value.id === this.personReceived.enterpriseId);
      if (selectedEnterprise.isPartner) {
        control.setErrors(null);
      } else {
        control.setErrors({isntPartner: true});
        control.markAsTouched();
      }
    } else {
      control.setErrors(null);
    }
  }

  public openModalAddEnterprise() {
    const modalRef = this.modalService.open(AddEditEnterpriseComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.enterprise = new Enterprise();
    modalRef.result.then((result) => {
      if (ParticipantType.User) {
        return;
      }
      const entityName = this.translate.instant('TITLE.ENTERPRISES');
      const informType = result.informType;
      if (InformType.Success === informType) {
        const enterprise = result.enterprise;
        this.enterpriseViewnameSelected = enterprise.documentNumber + ' - ' + enterprise.name;
        this.enterpriseViewSelected = enterprise;
        Dialog.show(InformType.Success, entityName);
      } else if (InformType.Warning === informType) {
        const enterprise = result.enterprise;
        this.enterpriseViewnameSelected = enterprise.documentNumber + ' - ' + enterprise.name;
        this.enterpriseViewSelected = enterprise;
        Dialog.show(InformType.Warning, entityName);
      } else if (InformType.Danger === informType) {
        Dialog.show(InformType.Danger, entityName);
      }
    });
  }

  public onAddDocumentImages(event) {
    if (event) {
      this.checkedAddImgDocument = true;
    } else {
      if (!this.hasImagesDocument) {
        this.cleanDocumentImages();
      }
      this.checkedAddImgDocument = this.hasImagesDocument;
    }
  }

  public cleanDocumentImages() {
    this.personForm.get('documentFrontFileBase64').setValue('');
    this.personForm.get('documentFrontFilename2Show').setValue('');
    this.loadDocumentFrontSrc(undefined);
    this.personForm.get('documentRearFileBase64').setValue('');
    this.personForm.get('documentRearFilename2Show').setValue('');
    this.loadDocumentRearSrc(undefined);
    this.loadDocumentpwfile(undefined);
  }

  changeStatus6(event: any) {
    this.moreAboutPerson = new MoreAboutPerson();
    this.moreAboutPerson.haveTwoFactorAuthentication = event;
    this.personReceived.moreAboutPerson = this.moreAboutPerson;
    if (event) {
      this.personForm.get('phoneNumber').setValidators(Validators.required);
    } else {
      this.personForm.get('phoneNumber').clearValidators();
    }
    this.personForm.get('phoneNumber').updateValueAndValidity();
  }

  get addOptSelected(): boolean {
    return Constant.ADD === this.purpose4Form || Constant.ADD_ON_DOCS === this.purpose4Form;
  }

  get addDocumentImages(): boolean {
    if (TypeSignature.CLOUD === this.typeSignature || (this.isElectronicSignature && this.hasImagesDocument)) {
      return true;
    } else {
      return this.checkedAddImgDocument;
    }
  }

  get isCloudSignature(): boolean {
    return TypeSignature.CLOUD === this.typeSignature;
  }

  get isElectronicSignature(): boolean {
    return TypeSignature.ELECTRONIC === this.typeSignature;
  }

  loadRole4InvitedUser(): void {
    const roles = LocalStorage.getRoles();
    this.roles = roles.filter(role => role.name === Constant.ROLE_USER);
  }

  isRoleSimple(role: Role): boolean {
    return role.name === Constant.ROLE_SIMPLE;
  }

  private loadResourcePerson() {
    this.loading = true;
    this.personService.loadResourcePerson(this.personReceived).subscribe(resourcePerson => {
      this.loading = false;
      if (resourcePerson) {
        this.personReceived._more.hasImagesDocument = resourcePerson._more.hasImagesDocument;
        this.loadRubricSrc(resourcePerson);
        this.loadDocumentFrontSrc(resourcePerson);
        this.loadDocumentRearSrc(resourcePerson);
        this.loadDocumentpwfile(resourcePerson);
        this.hasImagesDocument = resourcePerson._more.hasImagesDocument;
        this.checkedAddImgDocument = this.hasImagesDocument;
      }
    }, () => {
      this.loading = false;
    });
  }

  getBy(documentNumber: string) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/search/on-reniec/' + documentNumber + '/people');
    this.enterpriseService.get(url).subscribe((personFoundded: any) => {
      this.loading = false;
      if (personFoundded) {
        this.personReceived.documentNumber = personFoundded.documentNumber;
        this.personReceived.firstname = personFoundded.firstname;
        this.personReceived.lastname = personFoundded.lastname;
        this.personReceived.lastname2 = personFoundded.lastname2;
      }
    }, error => {
      this.loading = false;
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.PERSON'), error.error.message);
    });
  }

  changeStatus8(event: any) {
    this.changePasswordTemporary = event;
    if (event) {
      this.personForm.get('timeOnNumber').setValidators(Validators.compose([
        Validators.required,
        Validators.pattern('^[1-9][0-9]*$')
      ]));
      if (this.isNewPerson) {
        this.personForm.get('dateType').setValue(this.dateTypes[0]);
      }
    } else {
      this.personForm.get('dateType').clearValidators();
      this.personForm.get('timeOnNumber').clearValidators();
    }
    this.personForm.get('dateType').updateValueAndValidity();
    this.personForm.get('timeOnNumber').updateValueAndValidity();
  }


  changeStatus9(event: any) {
    this.passwordSecurityLevel = event;
    if (this.isNewPerson) {
      this.passwordLevelHighChecked = true;
      this.passwordLevelMedioChecked = false;
    }
  }

  changeStatus10(event: any, value: any) {
    this.passwordLevelHighChecked = event;
    this.passwordLevelMedioChecked = false;
    this.passwordLevel = value;
  }

  changeStatus11(event: any, value: any) {
    this.passwordLevelHighChecked = false;
    this.passwordLevelMedioChecked = event;
    this.passwordLevel = value;
  }

  /*Se comprime la imagen reduciendo el tamaño en 40% y se mantiene la calidad en un 40% siempre en cuando supera 1 MB*/
  verifyImageSizeAllowed(imageToCompress: any, name?: string): any {
    this.sizeOfOriginalImage = this.imageCompressService.byteCount(imageToCompress) / (1024 * 1024);
    console.log('Size in bytes is now:', this.sizeOfOriginalImage);
    if (this.sizeOfOriginalImage >= UnitMeasure.ONE_MB && imageToCompress !== '') {
      const orientation = -1;
      this.imageCompressService.compressFile(imageToCompress, orientation, 40, 40).then(result => {
        this.imageCompress = result;
        LocalStorage.setItem(name, result);
      });
    }
  }

  private getImageCompress(imageCompress: string, name?: string) {
    return LocalStorage.getImageCompress(imageCompress, name);
  }

  get enableBtnSearch() {
    return this.personReceived.documentNumber !== undefined ? this.personReceived.documentNumber.length === 8 && this.isNewPerson && this.isDni : false;
  }

  get isDni() {
    return Number(this.personReceived.documentType) === IdentificationDocument.DNI;
  }

  get isActive() {
    return Number(this.personReceived.active) === 1;
  }

  public async changeStatus1(event) {
    const fileSelected = event[Constant.ZERO_INDEX];
    if (!fileSelected.name.endsWith('.pdf')) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.ADD-DOCUMENT-BATCH'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
    this.personForm.patchValue({
      file: fileSelected.base64,
      filename: fileSelected.name,
      filename2Show: StringUtil.cut(fileSelected.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.hasPowerValidity = true;
    this.hasPowerValidity3 = true;
    const r = await fetch(fileSelected.base64);
    const blob = await r.blob();
    this.urlPowerValidity = URL.createObjectURL(blob);
  }

  public async changeStatus7(event) {
    const fileSelected = event[Constant.ZERO_INDEX];
    if (!fileSelected.name.endsWith('.pdf')) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.ADD-DOCUMENT-BATCH'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
    this.personForm.patchValue({
      rucFile: fileSelected.base64,
      rucFilename: fileSelected.name,
      rucFilename2Show: StringUtil.cut(fileSelected.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.hasRUCFile = true;
    this.hasRUCFile3 = true;
    const r = await fetch(fileSelected.base64);
    const blob = await r.blob();
    this.urlRUCFile = URL.createObjectURL(blob);
  }

  openModalPdfViewer(typeDocumentId: number) {
    const url = Constant.ROOT_API_V1
      .concat('/people/')
      .concat(String(this.personReceived.id))
      .concat('/persondocument/')
      .concat(String(typeDocumentId))
      .concat('/stream');
    let url1;
    let hasFile;
    let tittle;
    if (PersonDocumentType.RUC_FILE === typeDocumentId) {
      hasFile = this.personReceived._more !== undefined ? this.personReceived._more.hasRUCFile
        && !this.hasRUCFile3 : this.personReceived.hasRUCFile && !this.hasRUCFile3;
      tittle = 'LABEL.RUC-FILE';
      url1 = this.urlRUCFile;
    } else {
      hasFile = this.personReceived._more !== undefined ? this.personReceived._more.hasPowerValidity
        && !this.hasPowerValidity3 : this.personReceived.hasPowerValidity && !this.hasPowerValidity3;
      tittle = 'LABEL.POWER-VALIDITY';
      url1 = this.urlPowerValidity;
    }
    if (hasFile) {
      this.personService.download(url).subscribe(value => {
        // @ts-ignore
        const file = new Blob([value], {type: 'application/pdf'});
        url1 = URL.createObjectURL(file);
        const opemModal = this.modalService.open(TermPdfViewerComponent, {
          backdrop: 'static',
          size: 'lg'
        });
        opemModal.componentInstance.urlStream = url1;
        opemModal.componentInstance.title = this.translate.instant(tittle);
      }, () => {
      });

    } else {
      const opemModal = this.modalService.open(TermPdfViewerComponent, {
        backdrop: 'static',
        size: 'lg'
      });
      opemModal.componentInstance.urlStream = url1;
      opemModal.componentInstance.title = this.translate.instant(tittle);
    }
  }

  validateNumber(event: any) {
    const input = event.target;
    if (input.value < 0) {
      input.setCustomValidity('El número no puede ser negativo.');
    } else {
      input.setCustomValidity('');
    }
  }

  get hasPowerValidity1() {
    if (this.personReceived.id) {
      return this.personReceived._more !== undefined ? this.personReceived._more.hasPowerValidity || this.hasPowerValidity3 :
        this.personReceived.hasPowerValidity || this.hasPowerValidity3;
    } else {
      return this.hasPowerValidity3 !== null ? this.hasPowerValidity3 : false;
    }
  }

  get hasRUCFile1() {
    if (this.personReceived.id) {
      return this.personReceived._more !== undefined ? this.personReceived._more.hasRUCFile || this.hasRUCFile3 :
        this.personReceived.hasRUCFile || this.hasRUCFile3;
    } else {
      return this.hasRUCFile3 !== null ? this.hasRUCFile3 : false;
    }
  }

  get hasPowerValidity2(): string {
    return this.hasPowerValidity1 ? 'vigencia de poder.pdf' : this.translate.instant('MESSAGE.SELECT');
  }

  get hasRUCFile2(): string {
    return this.hasRUCFile1 ? 'Ficha RUC.pdf' : this.translate.instant('MESSAGE.SELECT');
  }

  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartnerModal(partnerId).subscribe(enterprises => {
      this.enterprises = enterprises.sort();
      this.personReceived.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
      this.reloadData();
    });
  }
}

